import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  cbtn: 'Confirm',
  headerInfo: {
    title: 'BLOOM Judge Management System',
    changePsd: ' Change password ',
    logout: 'Log out ',
    SelectActivity: 'Select Activity'
  },
  downLoad: 'Download',
  total: 'Total',
  loginPage: {
    title: ' Judge Assessment System ',
    account: 'Account login ',
    phoneSecurity: 'Verification code login',
    enterNuber: ' Please enter phone number ',
    psd: ' Please enter a 6-16 digit login password ',
    smsCode: ' Please enter verification code ',
    login: 'Log in ',
    changePsd: ' Change password ',
    longTxt: ' In order to protect your account security, please change your password immediately after the first login ',
    enterPsd: ' Please enter a new password ',
    reEnter: ' Please reenter the new password again ',
    authentication: ' Authentication ',
    alert: {
      success: ' Success ',
      subMitSus: 'Submitted successfully',
      changeSuc: ' Successfully modified '
    },
    sendSms: {
      is: 'Send',
      not: ' Reacquire '
    }
  },
  operatingSystem: {
    index: {
      list: {
        workManage: ' Assignment review ',
        workCorrecting: ' Test review '
      }
    },
    total: 'Total',
    count: '',
    listPage: {
      placeholder: {
        activity: 'Select an event ',
        workType: 'Select assignment type ',
        workName: 'Select a task',
        isReview: 'Select review status ',
        isPass: 'Choose review result ',
        teamName: 'Enter a team name ',
        studentName: 'Please enter student name',
        teamNum: 'Enter a team number ',
        describe: 'Please describe ',
        score: 'Please enter a score (0-100 points)',
        reviewOpinion: 'Please type in your comments '
      },
      label: {
        workType: {
          one: ' Personal assignment ',
          two: ' Team\'s assignment '
        },
        isReview: {
          one: ' unreviewed ',
          two: 'reviewed'
        },
        isPass: {
          one: 'fail',
          two: 'pass'
        },
        isCheat: {
          one: 'yes',
          two: 'no'
        },
        serial: ' No. ',
        teamName: ' Team name ',
        studentName: ' Full name ',
        firstName: ' First name ',
        lastName: ' Last name ',
        teamNum: ' Team number',
        schoolName: 'School name',
        taskName: 'Task name',
        submitTime: ' Submission time',
        reviewStatus: ' Review status',
        reviewTime: ' Review time',
        isPassText: 'Assessment result',
        score: ' Score ',
        reviewOpinion: ' Comment',
        reviewOpinion2: 'Comment[optional]',
        action: 'Action',
        edit: ' Review'
      },
      btn: {
        search: ' Search ',
        batchreview: ' Batch review',
        export: ' Export assignment',
        scan: ' View',
        edit: ' Assess',
        cancle: ' Cancel',
        submit: ' Submit',
        again: 'Double Check'
      },
      dialog: {
        title: ' Review records',
        isPass: 'Assessment Result：',
        againTitle: 'Submission Confirm？',
        score: 'Score：',
        reviewOpinion: 'Comment：',
        againTxt: 'Please confirm all the items have been scored before your submission。'
      },
      alert: {
        one: 'Please select the assignment that needs to be assessed first',
        two: 'This assignment does not support batch review. Please go to the assignment details for a single review.'
      }
    },
    infoPage: {
      none: 'Null',
      title: {
        main: 'Assignment details',
        edit: 'Edit',
        mainDetail: 'Assignment details',
        basic: ' Personal information',
        team: ' Team Information',
        work: 'Assignment',
        check: 'Approval Information',
        review: 'Review',
        reviewList: 'Review Progess'
      },
      form: {
        taskName: 'Assignment name',
        workDetail: 'Assignment',
        uploadFile: 'Document',
        preview: 'preview',
        download: 'download',
        judgeName: 'Judge',
        isCheatTxt: 'Cheating',
        scanList: 'Review Progress Tracking',
        tips: 'Your browser does not support the video tag.',
        downLoadAll: 'Download All Assignments',
        reviewUser: 'Review judges',  // judges
        scoreRequired: 'Please make sure all the required feedback items has been filled in and selected'
      },
      btn: {
        check: 'Review'
      }
    },
    testList: {
      selectTest: 'Select a test',
      selectSuccessStatus: 'Select finish status',
      finished: 'finished',
      unfinished: 'unfinished',
      search: 'Search',
      index: 'No.',
      test: 'Test',
      progress: 'Progress',
      finishStatus: 'Finish status',
      deadline: 'Deadline',
      actions: 'Actions',
      access: 'Access'
    },
    paperList: {
      selectName: 'Enter  student name',
      selectReviewStatus: 'Select review status',
      name: 'Name',
      reviewStatus: 'Review status',
      lastReviewTime: 'Last review time',
      review: 'review',
      view: 'view',
      reviewed: 'reviewed',
      unreviewed: 'unreviewed',
      noExam: 'The test no longer exists'
    },
    paperDesc: {
      total1: 'Total score: ',
      Writing: 'Writing',
      score: '',
      questions: 'Total questions: ',
      questions1: '',
      fullScore: 'Full score: ',
      score1: 'Score: ',
      submit: 'Submit',
      Previous: 'Previous test paper ',
      Next: 'Next test paper',
      resultChange: 'Score has changed,please switch the test paper after submitting the result.',
      reassigned: 'The papers have been reassigned',
      Refresh: 'Refresh',
      successfully: 'Submit successfully!',
      failed: 'Submit failed,please try again.',
      noResult: 'Please submit after reviewing all questions',
      stopSubmit: 'Reviewing has been stopped,unable to submit the result.',
      tips: 'Tips',
      tipContent: 'The current review results have not been submitted yet. Are you sure to leave now?',
      confirm: 'confirm',
      cancel: 'cancel'
    },
    router: {
      testList: 'Test list',
      testPaperList: 'Test paper list',
      testPaper: 'Test paper'
    }
  },
  ...enLocale
}

export default en



// WEBPACK FOOTER //
// ./src/assets/i18n/langs/en.js